<nb-actions size="tiny">
    <!-- <nb-action class="custom-action" link="pages/try-it-for-free" title="try it fro free">
        <a href="#"><i class="fa fa-shopping-cart"></i></a>
    </nb-action>
    <nb-action class="custom-action" link="pages/price" title="price">
        <a href="#"><i class="fa fa-user"></i></a>
    </nb-action>
    <nb-action class="custom-action" link="pages/blog" title="try it fro free">
        <a href="#"><i class="fa fa-shipping-fast"></i></a>
    </nb-action>
     -->
    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action> -->
    <nb-action class="control-item" icon="search-outline" (click)="activateSearch()">
        <nb-search type="rotate-layout"></nb-search>
    </nb-action>
    <nb-action class="control-item" icon="person-outline"></nb-action>
    <nb-action class="control-item" icon="shopping-cart-outline"></nb-action>
    <nb-action class="control-item" icon="heart-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action>
    <!-- <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name"
               [picture]="user?.picture">
      </nb-user>
    </nb-action> -->
  </nb-actions>

